<template>
  <SettingsPageLayout>
    <DashboardQuickstart @handle-setup-complete="handleSetupComplete" />
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../SettingsPageLayout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import Steps from '../shared/Steps.vue';
import RadialProgress from '../shared/RadialProgress.vue';
import DashboardQuickstart from '../dashboard_quickstart/DashboardQuickstart.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
    Steps,
    RadialProgress,
    DashboardQuickstart,
  },
  data() {
    return {
      steps: [
        {
          key: 'users_setup',
          name: 'Added supporting users to Humaniz (Recruiters, Sales Managers, Operations, etc.)',
          completed: true,
          link: '/settings/company/users',
        },
        {
          key: 'interviewer_calendars_setup',
          name: 'Connected interviewers calendars (Phone Screener, Interviewer, and Pipeline Reviewers)',
          completed: true,
          link: '/settings/account/calendar',
        },
        {
          key: 'phone_screener_setup',
          name: 'Assigned phone screener',
          completed: true,
          link: '/settings/company/users',
        },
        { key: 'interviewer_setup', name: 'Assigned interviewer', completed: true, link: '/settings/company/users' },
        {
          key: 'jobs_setup',
          name: 'Added a job with at least 7 cities',
          completed: false,
          link: '/jobs?sort=created&order=desc&status=Active',
        },
        {
          key: 'landing_page_setup',
          name: 'Created your landing page and requested a custom domain from support@humaniz.io',
          completed: true,
          link: '/settings/company/landing_pages',
        },
        {
          key: 'teammates_setup',
          name: 'Added your teammates into Humaniz',
          completed: false,
          link: '/team?status=Active&sort=created&order=desc',
        },
        {
          key: 'teammates_pipeline_reviewer_setup',
          name: 'Assigned your teammates to a pipeline reviewer',
          completed: false,
          link: '/team?status=Active&sort=created&order=desc',
        },
        {
          key: 'team_pipeline_reviews_setup',
          name: 'Enabled pipeline reviews for your team',
          completed: true,
          link: '/settings/workflows/team',
        },
      ],
      setupProgress: 0,
      loaded: false,
    };
  },
  mounted() {
    this.$store.commit('general/hideSetupBanner');
  },
  methods: {
    handleSetupComplete() {
      this.$router.push('/settings/account/profile');
      this.$store.commit('showAlert', {
        alertType: 'success',
        alertTitle: 'Guided Account Setup Complete!',
        alertDescription:
          'Congrats, you have completed the guided account setup. Use the button below to dismiss this alert.',
      });
    },
  },
};
</script>
